module.exports = __webpack_public_path__ + "3f16e137/img/print-icon.d8dbbca5.svg";